import * as R from "ramda";

const dataPush = function (data) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};

const constructObj = function (action, label, additionalParams) {
  var baseObj = {
    event: "gaGenericEvent",
    eventCategory: "BPR Calculator (local)",
    eventAction: action,
    eventLabel: label,
  };

  return additionalParams ? R.merge(baseObj, additionalParams) : baseObj;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  dataPush,
  constructObj,
};
